import { SignalRRequest } from '@adreno-common';

export class MessageRequest implements SignalRRequest {
  readonly name = 'Message';
  constructor(
    public payload: {
      group: string;
      message: string;
    }
  ) {}
}

export class PersonalChatRequest implements SignalRRequest {
  readonly name = 'PersonalChatOpen';
  constructor(
    public payload: {
      requestingUserId: number;
      userId: number;
    }
  ) {}
}

export class PersonalChatCloseRequest implements SignalRRequest {
  readonly name = 'PersonalChatClose';
  constructor(
    public payload: {
      requestingUserId: number;
      userId: number;
    }
  ) {}
}

export class GetChatroomUsersRequest implements SignalRRequest {
  readonly name = 'GetChatroomUsers';
  constructor(public payload: { chatroom: string }) {}
}

export class AddToGroupsRequest implements SignalRRequest {
  readonly name = 'AddToGroups';
  constructor(public payload: { groups: string[] }) {}
}

export type ChatSignalRRequests =
  | MessageRequest
  | PersonalChatRequest
  | PersonalChatCloseRequest
  | GetChatroomUsersRequest
  | AddToGroupsRequest;
